export default "__VITE_ASSET__BsM_L0vv__"